import { W as WuiBox$1, d as defineCustomElement$1 } from './p-BbTg3Car.js';

const WuiBox = WuiBox$1;
const defineCustomElement = defineCustomElement$1;

export { WuiBox, defineCustomElement };
